import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { UrlModal } from "../shared/url.model";

@Injectable({
  providedIn: "root"
})
export class AdService {
  constructor(private httpClient: HttpClient) {}

  saveAds(
    photo,
    startDate,
    endDate,
    adfor,
    advClientId,

    // line1,
    // district,
    city,
    // state,
    // pincode,
    // title,
    website,
    // description,
    token
  ) {
    var formData = new FormData();
    // formData.append('profileimage',image,image.name)
    // formData.append('profileimage',image,image.name)

    formData.append("adImage", photo, photo.name);
    formData.append("city", city);
    // formData.append("state", state);
    // formData.append("district", district);
    formData.append("endDate", endDate);
    // formData.append("pincode", pincode);
    formData.append("startDate", startDate);
    // formData.append("line1", line1);
    formData.append("adfor", adfor);
    if (advClientId) {
      formData.append("advClientId", advClientId);
    }
    // formData.append("title", title);
    formData.append("website", website);
    // formData.append("description", description);

    return this.httpClient.post(UrlModal._URL + "/ads/savead", formData, {
      headers: new HttpHeaders({
        authorization: "Bearer " + token
      })
    });
  }

  //getChangeList

  getChangeList(name, token) {
    return this.httpClient.post<changeListData>(
      UrlModal._URL + "/ads/getChangeList",
      {
        changeQuery: name
      },
      {
        headers: new HttpHeaders({
          authorization: "Bearer " + token
        })
      }
    );
  }
  sendSms(_id,token){
    return this.httpClient.get(UrlModal._URL+"/ad/sendSms/"+_id,{
      headers: new HttpHeaders({
        authorization: "Bearer " + token
      })
    })
  }
  todayUpdate(token:String){
    return this.httpClient.get(UrlModal._URL+"/ad/todayClinicUpdate",{
      headers: new HttpHeaders({
        authorization: "Bearer " + token
      })
    })
  }
}
interface changeListData {
  status: number;
  message: string;
  data: [{ _id: string; name: string }];
}
